import {AbstractNegotiationCloser} from "@/modules/diplomacy/services/AbstractNegotiationCloser";
import {inject, injectable} from "inversify";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {Negotiation} from "@/modules/diplomacy/entity";
import {YouthPlayerNegotiation} from "@/modules/youth/entity";
import {Recruiter} from "@/modules/youth/services/Recruiter";

@injectable()
export class YouthPlayerNegotiationCloser extends AbstractNegotiationCloser implements NegotiationCloserInterface {
  constructor(
    @inject(Recruiter) private recruiter: Recruiter,
  ) {
    super();
  }

  async shouldRun(negotiation: Negotiation) {
    await negotiation.load('team');

    return negotiation instanceof YouthPlayerNegotiation && await this.recruiter.canRecruit(negotiation.team);
  }

  async close(negotiation: YouthPlayerNegotiation): Promise<void> {
    await negotiation.load(['target', 'team']);

    if (negotiation.target.recruitedBy) {
      throw 'Player has been recruited already';
    }

    await this.recruiter.recruit(negotiation.target, negotiation.team);

    await this.endAllOtherNegotiations(negotiation);

    await super.close(negotiation);
  }
}